<table *ngIf="!agendaService.isLoading" mat-table [dataSource]="dataSource"
    class="mat-elevation-z8 no-header-tbl tareas-tbl" id="select-task-tbl">
    <caption></caption>

    <ng-container matColumnDef="iconSrc">
        <th id="iconSrc" mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let task"> <span class={{task.iconSrc}}></span> </td>
    </ng-container>

    <ng-container matColumnDef="fecha">
        <th id="fecha" mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let task"> {{task.fecha | date :'dd/MM/yyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="tarea">
        <th id="tarea" mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let task"> {{task.tarea | titlecase }} </td>
    </ng-container>

    <ng-container matColumnDef="empresa">
        <th id="empresa" mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let task"> {{task.empresaNombre | titlecase }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th id="name" mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let task" class="cursor-pointer" (click)="GoToEmployee(task.trabajadorId)">
            {{task.trabajadorSurname | titlecase}}, {{task.trabajadorName | titlecase}}
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th id="action" mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let task">
            <button aria-haspopup="true" class="navbar-toggle-button mat-icon-button icn-person"
                (click)="GoToEmployee(task.trabajadorId)">
                <span class="mat-button-wrapper">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                        person </mat-icon>
                </span>
                <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""
                    ng-reflect-centered="true"></div>
                <div class="mat-button-focus-overlay"></div>
            </button>

            <mat-menu #appMenu="matMenu">
                <button *ngIf="taskService.isPermitPrint && task.bloqueado == null" mat-menu-item
                    (click)="PrintDocument(task)">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                        print </mat-icon> Imprimir
                </button>
                <button *ngIf="taskService.isPermitChangeTime && task.bloqueado == null" mat-menu-item
                    (click)="addTimePopup(task)">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                        timer </mat-icon>Cambiar Hora
                </button>
                <button *ngIf="taskService.isPermitDeleteTask && task.bloqueado == null" mat-menu-item
                    (click)="deleteTask(task)">
                    <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                        delete_outline </mat-icon> Eliminar
                </button>
            </mat-menu>

            <button mat-icon-button [matMenuTriggerFor]="appMenu">
                <mat-icon>more_vert</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div class="p-16" *ngIf="agendaService.isLoading == true" class="m-auto">
    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
    </mat-progress-spinner>
</div>